import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";

import { PlatformTeamRole } from "../../../common/platformTypes";
import { useModalSubmit } from "../../../common/useModalSubmit";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (params: {
    identifier: string;
    role: PlatformTeamRole;
  }) => void | Promise<void>;
};

export const AddMemberModal: React.FunctionComponent<Props> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const [identifier, setIdentifier] = useState("");
  const [role, setRole] = useState<PlatformTeamRole>("viewer");
  const { submitting, error, submit } = useModalSubmit(isOpen);
  useEffect(() => {
    setIdentifier("");
    setRole("viewer");
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen}>
      <div className="modal-header">
        <h5 className="modal-title">Add Team Member</h5>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={onClose}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <ModalBody>
        <div className="form-group">
          <label>User</label>
          <input
            type="text"
            className="form-control"
            placeholder="platform user id or email"
            value={identifier}
            onChange={(e) => setIdentifier(e.currentTarget.value)}
          />
        </div>
        <div className="form-group">
          <label>Role</label>
          <select
            className="form-control"
            value={role}
            onChange={(e) => setRole(e.currentTarget.value as PlatformTeamRole)}
          >
            <option value="viewer">viewer</option>
            <option value="editor">editor</option>
          </select>
          {/* Owner is deliberately absent: the team's ownerId is a separate
              field, and ownership transfer is its own action. */}
          <span className="form-text text-muted">
            Editors consume a seat; viewers are free. The first editor on a team
            also makes its owner start consuming one.
          </span>
        </div>

        {error && <div className="alert alert-danger mb-0">{error}</div>}
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-light"
          disabled={submitting}
          onClick={onClose}
        >
          Close
        </button>
        <button
          className="btn btn-primary"
          disabled={!identifier.trim() || submitting}
          onClick={() =>
            void submit(() => onSubmit({ identifier: identifier.trim(), role }))
          }
        >
          {submitting ? "Adding…" : "Submit"}
        </button>
      </ModalFooter>
    </Modal>
  );
};
